export enum ResponseStatus {
  Fail = -1,
  Ok = 0
}
